import { Stack } from 'material-hu';
import { FormProvider, useForm } from 'react-hook-form';
import { FormTextField } from 'src/components/FormInputs';

// Temporary component for the LaComer team to adapt their webpage so it can work inside an iframe
const LaComerIframe = () => {
  const form = useForm({
    defaultValues: {
      url: 'https://rhuat.lacomer.com.mx/psc/HRMUAT/EMPLOYEE/HRMS/c/LC_RECIBOEMP_MENU.LC_VIS_DT_RCNM_CMP.GBL',
    },
  });
  return (
    <FormProvider {...form}>
      <Stack sx={{ width: '100vw', minHeight: '100vh' }}>
        <FormTextField
          fullWidth
          name="url"
        />
        <iframe
          style={{ flex: 1 }}
          width={'100%'}
          sandbox="allow-same-origin allow-scripts allow-forms"
          src={form.watch('url')}
        />
      </Stack>
    </FormProvider>
  );
};

export default LaComerIframe;
